import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgLift = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#00C5F2"
      d="M20 9H10v22h10z"
    />
    <path
      fill="#85E3F9"
      d="M30 9H20v22h10zM15 17a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
    />
    <path
      fill="#00C5F2"
      d="M25 29a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgLift);

export default ForwardRef;
